//@flow
import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import type { UserType, ErrorType } from '../../../utils/types';
import ValidatedField from '../../Validation/ValidatedField';

type Props = {
  user: UserType,
  errors: Array<ErrorType>,
  handlePersonalDataChange: (field: string, e: { target: HTMLInputElement }) => void,
};

const PersonalDataForm = (props: Props) => (
  <div>
    <FormGroup>
      <ControlLabel>First Name</ControlLabel>
      <ValidatedField field="first_name" errors={props.errors}>
        <FormControl
          onChange={e => props.handlePersonalDataChange('first_name', e)}
          value={props.user.first_name}
          type="text"
          autocomplete="given-name"
        />
      </ValidatedField>
    </FormGroup>
    <FormGroup>
      <ControlLabel>Last Name</ControlLabel>
      <ValidatedField field="last_name" errors={props.errors}>
        <FormControl
          onChange={e => props.handlePersonalDataChange('last_name', e)}
          value={props.user.last_name}
          type="text"
          autocomplete="family-name"
        />
      </ValidatedField>
    </FormGroup>
    <FormGroup>
      <ControlLabel>Email</ControlLabel>
      <ValidatedField field="email" errors={props.errors}>
        <FormControl
          onChange={e => props.handlePersonalDataChange('email', e)}
          value={props.user.email}
          type="email"
          autocomplete="email"
        />
      </ValidatedField>
    </FormGroup>
  </div>
);

export default PersonalDataForm;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/PersonalDataForm.js